export const FULL_REPORT_DOC_NAME = "Generated Main Summary (Part A)";
export const REPORT_ZIP_NAME = "REPORT_ZIP";
export const TECHNICAL_REPORT_NAME = "INS 06.0 - Part B - General Information";

export const inspectionElementNames = [
    FULL_REPORT_DOC_NAME,
    REPORT_ZIP_NAME,
    TECHNICAL_REPORT_NAME
];